(function () {
  'use strict';

  var SECTION_SELECTOR = '.oddit-section-faq';

  var ICON_DOWN_SVG =
    '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M3.75 7.5L10 13.75L16.25 7.5" stroke="#05302D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';

  var ICON_UP_SVG =
    '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M16.25 13.75L10 7.5L3.75 13.75" stroke="#05302D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';

  function setItemState(item, isOpen) {
    var trigger = item.querySelector('[data-faq-trigger]');
    var answer = item.querySelector('[data-faq-answer]');
    var icon = item.querySelector('.oddit-section-faq__icon');

    if (!trigger || !answer) return;

    if (isOpen) {
      item.classList.add('oddit-section-faq__item--open');
      trigger.setAttribute('aria-expanded', 'true');
      answer.removeAttribute('hidden');
      if (icon) icon.innerHTML = ICON_UP_SVG;
    } else {
      item.classList.remove('oddit-section-faq__item--open');
      trigger.setAttribute('aria-expanded', 'false');
      answer.setAttribute('hidden', '');
      if (icon) icon.innerHTML = ICON_DOWN_SVG;
    }
  }

  function filterByCategory(items, category) {
    var firstVisible = null;

    items.forEach(function (item) {
      var matches = item.getAttribute('data-faq-category') === category;
      item.hidden = !matches;

      if (matches) {
        // Show filtered-in items instantly — skip the reveal animation, which
        // otherwise leaves them stuck at opacity 0 (they were display:none when
        // the reveal observer ran, so it never marked them visible).
        item.classList.add('is-visible');

        if (!firstVisible) {
          firstVisible = item;
        } else {
          // Collapse any other items in the newly shown category.
          setItemState(item, false);
        }
      }
    });

    // Open the first item of the active category so the panel isn't empty.
    if (firstVisible) setItemState(firstVisible, true);
  }

  function initSection(section) {
    if (!section || section.dataset.odditFaqInit === 'true') return;
    section.dataset.odditFaqInit = 'true';

    var items = section.querySelectorAll('[data-faq-item]');

    items.forEach(function (item) {
      var trigger = item.querySelector('[data-faq-trigger]');
      if (!trigger) return;

      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('oddit-section-faq__item--open');
        setItemState(item, !isOpen);
      });
    });

    // Tabs filter the FAQ items by category.
    var tabs = section.querySelectorAll('[data-faq-tab]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          t.classList.remove('oddit-section-faq__tab--active');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('oddit-section-faq__tab--active');
        tab.setAttribute('aria-selected', 'true');

        filterByCategory(items, tab.getAttribute('data-faq-tab'));

        // Bring an off-screen tab into view within the horizontal scroller.
        tab.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
      });
    });

    // Apply the initial filter for the active (first) tab on load.
    var activeTab = section.querySelector('.oddit-section-faq__tab--active[data-faq-tab]') ||
      (tabs.length ? tabs[0] : null);
    if (activeTab) {
      filterByCategory(items, activeTab.getAttribute('data-faq-tab'));
    }
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  // Shopify theme editor support.
  document.addEventListener('shopify:section:load', function (event) {
    var target = event.target;
    if (!target) return;
    if (target.matches && target.matches(SECTION_SELECTOR)) {
      initSection(target);
    } else {
      initAll(target);
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var target = event.target;
    if (!target) return;
    var sections = target.matches && target.matches(SECTION_SELECTOR)
      ? [target]
      : target.querySelectorAll(SECTION_SELECTOR);
    sections.forEach(function (section) {
      delete section.dataset.odditFaqInit;
    });
  });
})();
